<div embeddedHTML class="diagnostic-expert-wrapper container-fluid py-5">
    <div class="container-xxxl py-lg-4">
        <div class="container-fluid pb-32">
            <div class="row">
                <h2 class="section-heading text-maroon border-maroon">{{ titleKA }}</h2>
            </div>
        </div>

        <div class="row align-items-start gx-4 gy-4 gy-xl-0">
            <div class="col-12 col-xl-6 ps-xl-5 order-1 order-xl-2 d-print-none">
                <img class="diagnostic-section-image img-fluid rounded-3 w-100" [src]="imgPath + mainKA.images[0]?.url + '-600.webp'" [alt]="mainKA.images[0]?.altText" />
            </div>

            <div class="col-12 col-xl-6 pe-xl-5 order-2 order-xl-1">
                <h3 class="mb-3 fs-5 fs-md-22 fw-bold lh-sm text-maroon">
                    {{ mainKA.title }}
                </h3>
                <clamper class="description d-block fs-6 fs-lg-18" [maxLines]="bodyMaxLines">
                    <div class="mb-4" [innerHTML]="mainKA.bodyText"></div>

                    <ng-container *ngIf="orgsWithExpertDirectory.length > 0">
                        <div class="link-list text-link" [innerHTML]="linkKA.bodyText"></div>
                        <ul class="mt-1 mb-0">
                            <li *ngFor="let org of orgsWithExpertDirectory">
                                <a class="link-list text-link fs-18" [href]="org.expertDirectoryUrl"
                                    >{{ org.name }}
                                    <i class="icon-gard-open-link"></i>
                                </a>
                            </li>
                        </ul>
                    </ng-container>

                    <ng-container *ngIf="orgsWithExpertDirectory.length === 0">
                        <div class="link-list text-link" [innerHTML]="nullKA.bodyText"></div>
                    </ng-container>
                </clamper>
            </div>
        </div>
    </div>
</div>
